import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const LaunchCountdown = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isLaunched, setIsLaunched] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      
      // Sett til 11. oktober 2025 kl. 12:00 (7 dager fra 4. oktober)
      const launchDate = new Date(2025, 9, 11, 12, 0, 0); // måned 9 = oktober (0-indeksert)
      
      const difference = launchDate.getTime() - now.getTime();

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
        
        // Smooth pulse only on seconds change
        setPulse(true);
        setTimeout(() => setPulse(false), 200);
      } else {
        setIsLaunched(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  if (isLaunched) {
    return (
      <div className="bg-brand-charcoal/70 backdrop-blur-sm px-4 py-2 border border-brand-gold/30 max-w-md mx-auto">
        <div className="text-center flex items-center justify-center gap-2">
          <span className="text-sm">✓</span>
          <span className="text-brand-gold font-semibold text-sm">På lager - levering 1-5 dager</span>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center">
      <div className="mb-4 md:mb-6 px-2">
        <h2 className="text-lg sm:text-xl md:text-3xl font-bold text-brand-gold font-orbit mb-2 break-words">
          RELANSERING - NY PWO
        </h2>
      </div>
      <div className="grid grid-cols-4 gap-2 md:gap-8 max-w-2xl mx-auto px-2">
        <div className={`text-center transform transition-all duration-200 ${pulse ? 'scale-105' : 'scale-100'}`}>
          <div className="text-3xl sm:text-4xl md:text-6xl font-black text-brand-gold font-orbit shadow-lg"
               style={{ 
                 textShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.4)',
                 filter: 'drop-shadow(0 4px 8px rgba(255, 215, 0, 0.3))'
               }}>
            {timeLeft.days.toString().padStart(2, '0')}
          </div>
          <div className="text-xs sm:text-sm md:text-lg text-brand-gold/90 font-bold tracking-wider animate-pulse">
            DAGER
          </div>
        </div>
        
        <div className={`text-center transform transition-all duration-200 ${pulse ? 'scale-105' : 'scale-100'}`}>
          <div className="text-3xl sm:text-4xl md:text-6xl font-black text-brand-gold font-orbit shadow-lg"
               style={{ 
                 textShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.4)',
                 filter: 'drop-shadow(0 4px 8px rgba(255, 215, 0, 0.3))'
               }}>
            {timeLeft.hours.toString().padStart(2, '0')}
          </div>
          <div className="text-xs sm:text-sm md:text-lg text-brand-gold/90 font-bold tracking-wider animate-pulse">
            TIMER
          </div>
        </div>
        
        <div className={`text-center transform transition-all duration-200 ${pulse ? 'scale-105' : 'scale-100'}`}>
          <div className="text-3xl sm:text-4xl md:text-6xl font-black text-brand-gold font-orbit shadow-lg"
               style={{ 
                 textShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.4)',
                 filter: 'drop-shadow(0 4px 8px rgba(255, 215, 0, 0.3))'
               }}>
            {timeLeft.minutes.toString().padStart(2, '0')}
          </div>
          <div className="text-xs sm:text-sm md:text-lg text-brand-gold/90 font-bold tracking-wider animate-pulse">
            MIN
          </div>
        </div>
        
        <div className={`text-center transform transition-all duration-200 ${pulse ? 'scale-105' : 'scale-100'}`}>
          <div className="text-3xl sm:text-4xl md:text-6xl font-black text-brand-gold font-orbit shadow-lg"
               style={{ 
                 textShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.4)',
                 filter: 'drop-shadow(0 4px 8px rgba(255, 215, 0, 0.3))'
               }}>
            {timeLeft.seconds.toString().padStart(2, '0')}
          </div>
          <div className="text-xs sm:text-sm md:text-lg text-brand-gold/90 font-bold tracking-wider animate-pulse">
            SEK
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchCountdown;